import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemRoyalTruffleLocator extends Item {
    constructor() {
        super(definitions.ITEM_ID.ROYAL_TRUFFLE_LOCATOR, texture("prop_royal_truffle_locator_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}